/**
 * Совместимость с двумя runtime'ами:
 *   • Telegram Mini App — есть настоящий `Telegram.WebApp`.
 *   • Браузер (app.zero-wallet.net) — Telegram-скрипт всё равно подключён
 *     из index.html, поэтому объект существует, но с пустой initData и
 *     no-op методами. Всё «Telegram-специфичное» (BackButton, MainButton,
 *     Haptic) в веб-режиме превращается в тихие заглушки — компонентам
 *     не нужно рефакториться под ветвление.
 */
const tg = (() => {
  try {
    return Telegram.WebApp;
  } catch {
    // Крайне маловероятно, но если по какой-то причине скрипт не
    // загрузился — возвращаем no-op-заглушку с минимальной поверхностью.
    // Мы её типизируем как настоящий `WebApp`, чтобы вызовы вида
    // `tg.BackButton.hide()` не сыпали в TS. Все методы — пустые функции.
    const noop = () => undefined;
    const stub = {
      initData: "",
      initDataUnsafe: { user: undefined },
      themeParams: {},
      colorScheme: "dark" as const,
      platform: "web",
      version: "0",
      viewportHeight: 0,
      viewportStableHeight: 0,
      isExpanded: true,
      BackButton: { show: noop, hide: noop },
      MainButton: {
        show: noop,
        hide: noop,
        setText: noop,
        onClick: noop,
        offClick: noop,
        enable: noop,
        disable: noop,
      },
      HapticFeedback: {
        impactOccurred: noop,
        notificationOccurred: noop,
        selectionChanged: noop,
      },
      ready: noop,
      expand: noop,
      close: noop,
      onEvent: noop,
      offEvent: noop,
      showAlert: noop,
      showConfirm: noop,
      openLink: noop,
      openTelegramLink: noop,
      requestFullscreen: noop,
    };
    return stub as unknown as typeof Telegram.WebApp;
  }
})();

export const useTelegram = () => {
  // initDataUnsafe.user — undefined в браузере, что естественно и корректно.
  const user = tg.initDataUnsafe?.user;
  const themeParams = tg.themeParams;

  return {
    tg,
    user,
    themeParams,
  };
};
